const activePackageFilters = {
  sportIds: 'sportIds',
  formatId: 'formatId',
  tagIds: 'tagIds',
};

export default activePackageFilters;
